module.exports = __webpack_public_path__ + "static/network-map2-e3785e901b43a2b00d0e1e7a7e060cc9.svg";